@if (chartsCountSg() === 1) {
  <!-- In case that there is only one chart, we want to display it on whole
  widget, and to avoid calculations for grid layout, only one chart is displayed
  without any classes-->
  <atn-ds-chart [chart]="chartsSg()[0]" />
} @else {
  <div
    #lineChartsContainer
    class="line-chart-grid-container"
    [style.--line-chart--min-width]="minWidth"
    [style.--line-chart--min-height]="minHeight"
    [style.--line-charts--max-columns]="columnsCountSg()"
    [style.--line-charts--rows]="rowsCountSg()"
    [style.--line-chart--container-height]="containerHeightSg()"
  >
    @for (chart of chartsSg(); track $index) {
      <atn-ds-chart [chart]="chart" />
    }
  </div>
}
